'use client'

export const Stamp = (props: { text?: string }) => {
  if (!props.text) return null

  return (
    <div className="rounded-[4px] bg-bodi-green-bright-500 px-1 font-sans text-[11px] leading-5 font-semibold text-bodi-black-text">
      {props.text}
    </div>
  )
}
